'use strict';

angular.module('atex.art').factory('ArtSynchronizationService',
  ['$q', '$rootScope', '$timeout', 'ApplicationConfigurationService', 'AuthenticationService', 'ArtNotificationService',
    'ArtSyncModal', 'ArtTemplateStore', 'ArtContentStore', 'ArtUserDataStore', 'ArtLocalizationService',

    function($q, $rootScope, $timeout, ApplicationConfigurationService, AuthenticationService, ArtNotificationService,
             ArtSyncModal, ArtTemplateStore, ArtContentStore, ArtUserDataStore, ArtLocalizationService) {

    var _isSyncInProgress = false;
    var _consecutiveSyncFails = 0;
    var _persistentErrorToast = undefined;
    var syncDeferred = $q.defer();
    var SYNCHRONIZATION_MIN_DELAY = 5000;
    var SYNCHRONIZATION_DEFAULT_DELAY = 60000;

    // true when the synchronization has been asked at least once.
    var _isSyncStarted = false;
    
    // will contain the list of ids to be kept synchronized, empty means all.
    var _filterIds = [];

    // when true to ids will be kept synchronized.
    var _onlyTemplates = false;

    // this promise is used to make sure the sync dialog do not
    // appear on top of a authentication dialog.
    var loggedInDeferred = $q.defer();

    var waitForLoggedIn = function(doVerify) {

      // doVerify should be true before presenting the dialog.
      // in this case we should use the verifyLoggedIn which will
      // trigger the authentication dialog if the user is not
      // logged in.

      if (doVerify) {
        return AuthenticationService.verifyLoggedIn().then(function (token) {
          loggedInDeferred.resolve();
        }, function () {
          return loggedInDeferred.promise;
        });
      } else {
        return loggedInDeferred.promise;
      }
    };

    $rootScope.$on("onecms:authenticationSuccess", function() {

      // user have successfully authenticated so we can resolve
      // the deferred.

      loggedInDeferred.resolve();
    });

    var synchronizationNotify = function(errorMessages) {
      if (errorMessages.length > 0) {
        var message = 'Error synchronizing with the server! Please see the notification center for more information.';
        var childNotifications = errorMessages.map(function(message) { return atex.act.Notification({ type: 'error', message: message }); });

        ArtNotificationService.addNotification(atex.act.Notification({ type: 'warning', message: message, notifications: childNotifications }), true);
      }
    };

    var collectSynchronizationErrors = function(errorMessages, results, message) {
      if (results.rejected.length > 0) {
        var messages = results.rejected.filter(function(error) {
          if (typeof error.shouldRemoveFromLocal !== 'undefined' && error.shouldRemoveFromLocal) {
            return false;
          }
          return !error.hasFailedBefore;
        }).map(function(error) {
          console.log(message, error);
          return error.cause;
        });

        errorMessages = errorMessages.concat(messages);
      }

      return errorMessages;
    };

    var dosync = function(options, translations) {

      var fullForegroundSync = (options || {}).foreground || false;
      var excludeIds = (options || {}).excludeIds;
      var onlyTemplates = (options || {}).onlyTemplates || _onlyTemplates;

      // if we have been requested to synchronize only templates
      // and the there are no ids being synchronized than we
      // will start the autosync with only templates.

      if (_filterIds.length === 0) {
        _onlyTemplates = onlyTemplates;
      }

      _isSyncStarted = true;

      var syncErrs = [];
      var splitSettled = atex.onecms.AngularUtils.splitSettled;

      if (_isSyncInProgress) {
        console.log("Data synchronization is already in progress, skipping...");
        return $q.when();
      }

      _isSyncInProgress = true;

      return AuthenticationService.getCurrentUser().then(function (currentUser) {
        return waitForLoggedIn(fullForegroundSync).then(function() {
          var currentUserData = undefined;

          $rootScope.$broadcast("atex:synchronizationStart");

          var synchronizationInformer = (fullForegroundSync)
            ? ArtSyncModal.create({actionHeader: translations.PREPARING_APPLICATION})
            : { setActionMessage: function() {}, setProgress: function() {}, destroy: function() { return $q.when(); } };

          var work = $q.when();

          if (fullForegroundSync) {
            synchronizationInformer.setActionMessage(translations.SYNCHRONIZING_TEMPLATES);
            work = ArtTemplateStore.sync();
          }

          return work.then(function () {
            synchronizationInformer.setActionMessage(translations.SYNCHRONIZING_USER_DATA);
            return ArtUserDataStore.sync();
          }).then(function (results) {
            syncErrs = collectSynchronizationErrors(syncErrs, results, 'WARNING: Error synchronizing user data:');
            return ArtUserDataStore.getById(currentUser.userId);
          }).then(function (userData) {
            currentUserData = userData;

            var userContent = (currentUserData.aspects.contentData.data.myOneCMSContent || []).map(function (myContentId) {
              //return 'policy:' + (myContentId.value || myContentId).replace('contentid/', '');
              //Hack untill onecms provider changed to return new contentIds
              var washedId = (myContentId.value || myContentId).replace('contentid/', '');
              return (washedId.indexOf(':') === -1) ? 'policy:' + washedId : washedId;
            });

            // if we need to synchronize only templates, than ignore the user list.
            if (typeof onlyTemplates !== 'undefined' && onlyTemplates) {
              userContent = [];
            } else {

              // if we received a list of ids to be kept synchronized than we will add it to the
              // current list we already have.

              if (typeof options.ids !== 'undefined' && _.isArray(options.ids) && options.ids.length > 0) {
                _filterIds = _.uniq([].concat(_filterIds).concat(options.ids));
                userContent = _.filter(userContent, function (id) {
                  return _.contains(options.ids, id);
                });
              } else {
                _filterIds = _.uniq([].concat(_filterIds).concat(userContent));
              }
            }

            return $q.allSettled(userContent.map(function (myContentId) {
              return ArtContentStore.getById(myContentId).then(null, function (error) {
                // Avoid reporting errors for new articles that have not been seen before since they might not be
                // seen due to out of sync changelists in the data-api and the solr-indexing webapp.

                if (error.type === atex.onecms.error.types.NOT_FOUND) {
                  console.log('Got NOT_FOUND for content in My OneCMS Content list, ignoring and hoping it will turn up after a while', error);
                  return $q.when();
                }

                return $q.reject(error);
              });
            }));
          }).then(function (results) {
            var ids;

            if (results.length > 0) {
              ids = atex.onecms.AngularUtils.splitSettled(results).fulfilled.map(function (v) {
                return v.meta.id;
              });
            }

            syncErrs = collectSynchronizationErrors(syncErrs, splitSettled(results), 'WARNING: Error synchronizing user content:');
            synchronizationInformer.setActionMessage(translations.SYNCHRONIZING_CONTENT);
            synchronizationInformer.setProgress(0);

            if (onlyTemplates) {
              // we have been asked to synchronise only templates
              // so we will simulate an empty response.
              return {
                rejected: [],
                fulfilled: []
              };
            } else {
              return ArtContentStore.sync({
                ids: ids,
                onProgress: synchronizationInformer.setProgress.bind(synchronizationInformer),
                excludeIds: excludeIds
              });
            }
          }).then(function (results) {
            syncErrs = collectSynchronizationErrors(syncErrs, results, 'WARNING: Error synchronizing content:');

            synchronizationNotify(syncErrs);

            _isSyncInProgress = false;
            $rootScope.$broadcast("atex:synchronizationEnd");

            if (_persistentErrorToast !== undefined) {
              ArtNotificationService.clearToast(_persistentErrorToast);
              _persistentErrorToast = undefined;
            }

            _consecutiveSyncFails = 0;

            syncDeferred.resolve();

            return synchronizationInformer.destroy();
          }).then(null, function (error) {
            console.log('ERROR: Performing application sync:', error);

            _isSyncInProgress = false;
            $rootScope.$broadcast("atex:synchronizationEnd");

            if (_consecutiveSyncFails === 0) {
              ArtNotificationService.addNotification(atex.act.Notification({
                type: 'error',
                message: error.cause
              }), true);
            } else if (_consecutiveSyncFails === 1) {
              _persistentErrorToast = ArtNotificationService.addNotification(atex.act.Notification({
                type: 'error',
                message: 'The dm.editor has failed to perform synchronization two times in a row. Something might be wrong with your network connectivity.',
                persistent: true
              }), false, function () {
              });
            }

            _consecutiveSyncFails++;
            syncDeferred.resolve();
            return synchronizationInformer.destroy();
          });
        });
      });
    };

    var sync = function(options) {
      return ArtLocalizationService.translate(['PREPARING_APPLICATION', 'SYNCHRONIZING_TEMPLATES', 'SYNCHRONIZING_USER_DATA', 'SYNCHRONIZING_CONTENT']).then(function(translations) {
        return dosync(options, translations);
      });
    };

    var autoSynchronizer = function(excludeIds, autoFlag) {
      var that = this;

      if (that.delay <= 0) {
        return;
      }

      that.timerPromise = $timeout(function() {
        that.syncPromise = sync({
          foreground: false,
          excludeIds: excludeIds,
          ids: _filterIds,
          onlyTemplates: _onlyTemplates && _filterIds.length === 0
        });

        that.syncPromise.then(function() {
          if (!autoFlag.cancel) {
            autoSynchronizer.call(that, excludeIds, autoFlag);
          }
        }, function(error) {
          console.log(error);
        });
      }, that.delay, true);
    };

    var serverConfigurationUpdate = function() {
      var that = this;
      var defaultDelay = 60;

      $timeout(function() {
        ApplicationConfigurationService.getConfigurationFor(['serverDataSynchronization', 'timeInSecondsBetweenSync'], defaultDelay).then(function(delayInSeconds) {
          var delay = (!_.isNumber(delayInSeconds)) ? defaultDelay : delayInSeconds;

          that.delay = delay * 1000;
        }, function(error) {
          console.log("ERROR: When reading server configuration for server data synchronization:", error);
        });
      }, 0, true);
    };

    return {
      enableAutoSync: function(excludeIds) {
        if (this.timerPromise !== undefined) {
          this.excludes = excludeIds;
          this.autoFlag.cancel = true;
          this.autoFlag = undefined;

          $timeout.cancel(this.timerPromise);
        }

        this.autoFlag = { cancel: false };
        autoSynchronizer.call(this, excludeIds, this.autoFlag);
      },

      updateDelayFromServerConfiguration: serverConfigurationUpdate,

      get delay() {
        if (typeof this._delay === 'undefined') {
          this._delay = SYNCHRONIZATION_DEFAULT_DELAY;
        }

        return this._delay;
      },

      set delay(ms) {
        this._delay = (ms >= 0) ? Math.max(ms, SYNCHRONIZATION_MIN_DELAY) : ms;

        if (this._delay > 0) {
          this.enableAutoSync(this.excludes);
        }
      },

      disableAutoSync: function() {
        if (this.syncFlag) {
          this.autoFlag.cancel = true;
          this.autoFlag = undefined;
        }

        return $timeout.cancel(this.timerPromise);
      },

      synchronize: function(blocking) {
        var options = blocking || {};
        if (_.isObject(options)) {
          return sync(options);
        } else {
          return sync({
            foreground: blocking
          });
        }
      },

      whenSynchronized: function (options) {
        var _options = _.extend({ foreground: !_isSyncStarted }, options || {});
        if (_isSyncStarted) {
          if (typeof _options.ids !== 'undefined' && _.isArray(_options.ids)) {
            if (_options.ids.length > 0 && _onlyTemplates) {
              _onlyTemplates = false;
            }
            if (_.every(_options.ids, function(id) { return _.contains(_filterIds, id); })) {
              return syncDeferred.promise;
            } else {
              _options.ids = _.uniq([].concat(_options.ids).concat(_filterIds));
              return this.synchronize(_options);
            }
          } else if (typeof _options.all !== 'undefined' && _options.all) {
            var syncAgain = _filterIds.length > 0;
            if (_onlyTemplates) {
              _onlyTemplates = false;
              syncAgain = true;
            }
            if (syncAgain) {
              return this.synchronize(_options);
            }
          }
          return syncDeferred.promise;
        } else {
          this.updateDelayFromServerConfiguration();
          return this.synchronize(_options);
        }
      },

      isSyncInProgress: function() {
        return _isSyncInProgress;
      }

    };
  }
]);
